import moment from 'moment';
import PropTypes from 'prop-types';
import { Form, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import ProjectTypes from '../../../../constants/ProjectTypes';
export const ProjectInfo = ({ project }) => {
  const [t] = useTranslation();

  return project.type === ProjectTypes.COACH ? (
    <Form.Group as={Col}>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>Businesssituation</Form.Label>
          <div className="primary-text">{project.business_situation}</div>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Coachinganliegen/Thema</Form.Label>
          <div className="primary-text">{project.coaching_topic}</div>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>Führungsebene</Form.Label>
          <div className="primary-text">{project.leadership_level}</div>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Anschlussmaßnahmen</Form.Label>
          <div className="primary-text">{project.follow_on_action}</div>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>Ort des Coachings</Form.Label>
          <div className="primary-text">{project.location || 'Virtuell'}</div>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>Erwartungen</Form.Label>
          <div className="primary-text">{project.expectations}</div>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>Anmerkungen</Form.Label>
          <div className="primary-text">{project.comments}</div>
        </Form.Group>
      </Row>
    </Form.Group>
  ) : (
    <Form.Group as={Col}>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>Teilnehmerzahl</Form.Label>
          <div className="primary-text">{project.numParticipants}</div>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Bevorzugte Sprache der Coachings</Form.Label>
          <div className="primary-text">{t(project.language)}</div>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>Ort des Workshops</Form.Label>
          <div className="primary-text">
            {project.location || t('Virtuell')}
          </div>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Startdatum</Form.Label>
          <div className="primary-text">{moment(project.date).format('L')}</div>
        </Form.Group>
      </Row>
      <Row>
        <Form.Group as={Col}>
          <Form.Label>Anmerkungen</Form.Label>
          <div className="primary-text">{project.comments}</div>
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>Unit</Form.Label>
          <div className="primary-text">{project.unit}</div>
        </Form.Group>
      </Row>
      {project.leadership_level && (
        <Row>
          <Form.Group as={Col}>
            <Form.Label>Führungsebene</Form.Label>
            <div className="description">{project.leadership_level}</div>
          </Form.Group>
        </Row>
      )}
    </Form.Group>
  );
};

ProjectInfo.propTypes = {
  project: PropTypes.object.isRequired,
};

export default ProjectInfo;
